import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

import Paper from 'src/components/paper';
import TooltipedText from 'src/components/tooltipedText';
import DateRangePicker from 'src/components/dateRangePicker';

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(2),
  },
}));

export default function () {
  const classes = useStyles();
  return (
    <Paper>
      <div className={classes.header}>
        <TooltipedText tooltipText="Applies to all sections below">
          <Typography variant="h2">Reporting Date Range</Typography>
        </TooltipedText>
      </div>
      <DateRangePicker />
    </Paper>
  );
}
